<template>
  <div v-if="npsAccess.userDetails && npsAccess.courseData" class="feedback">
    <Header />
    <div style="margin-top: 64px" />
    <div class="banner-container">
      <img class="banner" src="@/assets/images/NPS Banner.2x.png" alt="banner" />
    </div>
    <form class="feedback-form" v-if="submit" @submit.prevent="submitForm">
      <h2 class="heading">We Value Your Feedback !</h2>
      <p class="details">
        Hey! Congratulations on completing the
        <strong>{{npsAccess.courseData.product_name}}</strong>
      </p>
      <p class="details">
        You are officialy an innovator now. We would love to know more about
        your experience with us.
      </p>
      <div class="fillingForChild" v-if="!form_detail.studentName">
        <input type="checkbox" class="checkbox" v-model="checked" v-on:keydown.enter.prevent /><label>I am filling it for my child</label>
      </div>
      <hr style="color: rgba(25, 25, 25, 0.32)" />

      <div v-if="checked">
        <label class="label-head required">Student's Name</label>
        <input type="text" class="col-12 p-2 name" placeholder="Add Name" autocomplete="off" v-model="$v.form_detail.studentName.$model" value="self" v-on:keydown.enter.prevent  :class="$v.form_detail.studentName.$invalid && validate && 'validate-fail'" />
        <div class="in-valid" v-if="$v.form_detail.studentName.$invalid && validate">* Please fill the required field</div>
      </div>

      <label class="label-head required">We delivered to our promise.</label>
      <div class="radio" :class="$v.form_detail.delivered.$invalid && validate && 'validate-fail'">
        <div class="radio-item only-four"><input type="radio" value="Strongly disagree" v-model="$v.form_detail.delivered.$model" v-on:keydown.enter.prevent /><label class="radio-label">Strongly disagree</label></div>
        <div class="radio-item only-four"><input type="radio" value="Disagree" v-model="$v.form_detail.delivered.$model" v-on:keydown.enter.prevent /><label class="radio-label">Disagree</label></div>
        <div class="radio-item only-four"><input type="radio" value="Agree" v-model="$v.form_detail.delivered.$model" v-on:keydown.enter.prevent /><label class="radio-label">Agree</label></div>
        <div class="radio-item only-four"><input type="radio" value="Strongly agree" v-model="$v.form_detail.delivered.$model" v-on:keydown.enter.prevent /><label class="radio-label">Strongly agree</label></div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.delivered.$invalid && validate">* Please select the required field</div>

      <label class="label-head required">I liked my course because:</label>
      <div class="check-container" :class="$v.form_detail.likeReason.$invalid && validate && 'validate-fail'">
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The explanations are clear" v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeReason.includes(`None of the above - I did not like my course`)" /><label>The explanations are clear</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The subject is well organized" v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeReason.includes(`None of the above - I did not like my course`)" /><label>The subject is well organized</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Enough homework is given to understand the concepts" v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeReason.includes(`None of the above - I did not like my course`)" /><label>Enough homework is given to understand the concepts</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The pace of the class was comfortable" v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeReason.includes(`None of the above - I did not like my course`)" /><label>The pace of the class was comfortable</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The course increased my interest and  knowledge of the subject." v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeReason.includes(`None of the above - I did not like my course`)" /><label>The course increased my interest and  knowledge of the subject.</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="None of the above - I did not like my course" v-model="$v.form_detail.likeReason.$model" v-on:keydown.enter.prevent :disabled="!this.form_detail.likeReason.includes(`None of the above - I did not like my course`) && this.form_detail.likeReason.length >= 1" /><label>None of the above - I did not like my course</label>
        </div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.likeReason.$invalid && validate">* Please select at least one value</div>

      <label class="label-head required">I like my teacher because:</label>
      <div class="check-container" :class="$v.form_detail.likeTeacher.$invalid && validate && 'validate-fail'">
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The teacher explains well" v-model="$v.form_detail.likeTeacher.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeTeacher.includes(`I do not like my teacher`)" /><label>The teacher explains well</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The teacher cares about how well I’m doing" v-model="$v.form_detail.likeTeacher.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeTeacher.includes(`I do not like my teacher`)" /><label>The teacher cares about how well I’m doing</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The teacher supported me well outside of the class" v-model="$v.form_detail.likeTeacher.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeTeacher.includes(`I do not like my teacher`)" /><label>The teacher supported me well outside of the class</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="The teacher checks on my homework in every class" v-model="$v.form_detail.likeTeacher.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeTeacher.includes(`I do not like my teacher`)" /><label>The teacher checks on my homework in every class</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="I do not like my teacher" v-model="$v.form_detail.likeTeacher.$model" v-on:keydown.enter.prevent :disabled="!this.form_detail.likeTeacher.includes(`I do not like my teacher`) && this.form_detail.likeTeacher.length >= 1" /><label>I do not like my teacher</label>
        </div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.likeTeacher.$invalid && validate">* Please select at least one value</div>

      <label class="label-head required">What do you most like about Avishkaar?</label>
      <div class="check-container" :class="$v.form_detail.likeMost.$invalid && validate && 'validate-fail'">
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Kit" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Kit</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Avishkaar Maker Studio" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Avishkaar Maker Studio</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Trainer" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Trainer</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Assignments" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Assignments</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Support" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Support</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Curriculum" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.likeMost.includes(`All the above`)" /><label>Curriculum</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="All the above" v-model="$v.form_detail.likeMost.$model" v-on:keydown.enter.prevent :disabled="!this.form_detail.likeMost.includes(`All the above`) && this.form_detail.likeMost.length >= 1" /><label>All the above</label>
        </div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.likeMost.$invalid && validate">* Please select at least one value</div>

      <label class="label-head required">On a scale of 1-10, tell us how likely are you to recommend Avishkaar
        Courses to a friend or a colleague ?</label>
      <div class="radio" :class="$v.form_detail.recommend.$invalid && validate && 'validate-fail'">
        <div class="radio-item"><label>1</label><input type="radio" value="1" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /><label class="radio-label">Not At All</label></div>
        <div class="radio-item"><label>2</label><input type="radio" value="2" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>3</label><input type="radio" value="3" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>4</label><input type="radio" value="4" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>5</label><input type="radio" value="5" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>6</label><input type="radio" value="6" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>7</label><input type="radio" value="7" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>8</label><input type="radio" value="8" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>9</label><input type="radio" value="9" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>10</label><input type="radio" value="10" v-model="$v.form_detail.recommend.$model" v-on:keydown.enter.prevent /><label class="radio-label">Would Love To</label></div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.recommend.$invalid && validate">* Please select the required field</div>

      <!-- <label class="label-head required">On a scale of 1-10, how much you liked your course ?</label>
      <div class="radio" :class="$v.form_detail.liked.$invalid && validate && 'validate-fail'">
        <div class="radio-item"><label>1</label><input type="radio" value="1" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /><label class="radio-label">Terrible</label></div>
        <div class="radio-item"><label>2</label><input type="radio" value="2" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>3</label><input type="radio" value="3" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>4</label><input type="radio" value="4" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>5</label><input type="radio" value="5" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>6</label><input type="radio" value="6" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>7</label><input type="radio" value="7" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>8</label><input type="radio" value="8" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>9</label><input type="radio" value="9" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>10</label><input type="radio" value="10" v-model="$v.form_detail.liked.$model" v-on:keydown.enter.prevent /><label class="radio-label">Awesome</label></div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.liked.$invalid && validate">* Please select the required field</div>

      <label class="label-head required">On a scale of 1-10, tell us how much you liked your mentor ?</label>
      <div class="radio" :class="$v.form_detail.mentor.$invalid && validate && 'validate-fail'">
        <div class="radio-item"><label>1</label><input type="radio" value="1" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /><label class="radio-label">Terrible</label></div>
        <div class="radio-item"><label>2</label><input type="radio" value="2" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>3</label><input type="radio" value="3" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>4</label><input type="radio" value="4" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>5</label><input type="radio" value="5" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>6</label><input type="radio" value="6" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>7</label><input type="radio" value="7" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>8</label><input type="radio" value="8" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>9</label><input type="radio" value="9" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /></div>
        <div class="radio-item"><label>10</label><input type="radio" value="10" v-model="$v.form_detail.mentor.$model" v-on:keydown.enter.prevent /><label class="radio-label">Awesome</label></div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.mentor.$invalid && validate">* Please select the required field</div>
      
      <label class="label-head required">What are the three things you valued the most about us ?</label>
      <div class="check-container" :class="$v.form_detail.valuedMost.$invalid && validate && 'validate-fail'">
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Course Content" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Course Content</label></div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="AMS - Avishkaar Maker" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>AMS - Avishkaar Maker Studio</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Avishkaar Kit" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Avishkaar Kit</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Trainers" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Trainers</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Teaching Assistants" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Teaching Assistants</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Assignments" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Assignments</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Assignment Evaluation" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Assignment Evaluation</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Course Report" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Course Report</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Transparency" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Transparency</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Customer Report" v-model="$v.form_detail.valuedMost.$model" v-on:keydown.enter.prevent /><label>Customer Support</label>
        </div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.valuedMost.$invalid && validate">* Please select at least three values</div>

      <label class="label-head required">Areas we could improve upon ?</label>
      <div class="check-container" :class="$v.form_detail.improve.$invalid && validate && 'validate-fail'">
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="No, everything is great" v-model="$v.form_detail.improve.$model" :disabled="!this.form_detail.improve.includes(`No, everything is great`) && this.form_detail.improve.length >= 1 " v-on:keydown.enter.prevent /><label>No, everything is great</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Course Content" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Course Content</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="AMS - Avishkaar Maker" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>AMS - Avishkaar Maker Studio</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Avishkaar Kit" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Avishkaar Kit</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Trainers" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Trainers</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Teaching Assistants" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Teaching Assistants</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Assignment Evaluation" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Assignment Evaluation</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Course Report" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Course Report</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Transparency" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Transparency</label>
        </div>
        <div class="check-item">
          <input type="checkbox" class="checkbox" value="Customer Report" v-model="$v.form_detail.improve.$model" v-on:keydown.enter.prevent :disabled="this.form_detail.improve.includes(`No, everything is great`)" /><label>Customer Support</label>
        </div>
      </div>
      <div class="in-valid" v-if="$v.form_detail.improve.$invalid && validate">* Please select at least one value</div>

      <label class="label-head">We would love to hear more from you. Share a feedback for you mentor,
        your classes, projects or anything.</label>
      <textarea class="col-12 p-2 name" rows="7" placeholder="Add Feedback" autocomplete="off" value="" v-model="$v.form_detail.shareFeedback.$model" /> -->

      <label class="label-head required">What is the primary reason for your above rating?</label>
      <textarea class="col-12 p-2 name" rows="3" placeholder="Your Answer" autocomplete="off" value="" v-model="$v.form_detail.recommendReason.$model" />

      <label class="label-head">What could we do to make you say ‘WOW’?</label>
      <textarea class="col-12 p-2 name" rows="3" placeholder="Your Answer" autocomplete="off" value="" v-model="$v.form_detail.wow.$model" />

      <div class="button">
        <button type="submit" @click="validate=true" class="ab-btn">{{submitButton}}</button>
        <div class="button-disabled in-valid" v-if="$v.form_detail.$invalid && validate">Please fill all the details marked with asterisk *</div>
      </div>
    </form>

    <div class="feedback-success-container" v-if="!submit">
      <div class="feedback-success">
        <h2 class="heading">Thank You For Sharing Your Feedback !</h2>
        <p class="details">
          We are glad you enjoyed your course with us. Journey to innovation
          does not stop here, do get in touch with your counselor to know about
          what’s further from here.
        </p>
        <div class="button"><router-link :to="'/shop/'"><button class="ab-btn">Explore Shop</button></router-link></div>
      </div>
    </div>

    <Footer style="width: 100%" />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, numeric, alpha, requiredIf } from "vuelidate/lib/validators";
const minValuedMost = (value, vm) => vm.valuedMost.length > 2;
const minlikeReason = (value, vm) => vm.likeReason.length;
const likeTeacher = (value, vm) => vm.likeTeacher.length;
const likeMost = (value, vm) => vm.likeMost.length;
export default {
  name: "DemoFeedback",
  mixins: [validationMixin],
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      get_web_path: process.env.VUE_APP_SITE_URL,
      checked: false,
      submit: true,
      submitButton: "Submit",
      validate: false,
      form_detail: {
        studentName: "",
        recommend: "",
        // liked: "",
        // mentor: "",
        // valuedMost: [],
        // improve: [],
        // shareFeedback: "",
        delivered: "",
        likeReason: [],
        likeTeacher: [],
        likeMost: [],
        recommendReason: "",
        wow: "",
      },
    };
  },
  validations: {
    form_detail: {
      studentName: { required: requiredIf(function() { return this.checked })},
      recommend: { required, numeric },
      // liked: { required, numeric },
      // mentor: { required, numeric },
      // valuedMost: { minValuedMost },
      // improve: { required },
      // shareFeedback: {},
      delivered: { required },
      likeReason: { minlikeReason },
      likeTeacher: { likeTeacher },
      likeMost: { likeMost },
      recommendReason: { required },
      wow: { },
    },
  },
  watch: {
    npsAccess: function(newVal, oldVal){
      if(newVal.userDetails && (newVal.userDetails.user_type == "student"  || this.npsAccess.userDetails.user_type == 'child'))
        this.$v.form_detail.studentName.$model = "self"
    }
  },
  computed: {
    ...mapGetters({ npsAccess : "getNpsAccess"})
  },
  created() {
    if(this.$cookies.get('userAccess') !== null && this.$cookies.get('classCode') !== null && this.$cookies.get('accessCode') !== null)
      this.checkNpsClassAccess({"classCode" : this.$cookies.get('classCode'), "accessCode" : this.$cookies.get('accessCode')});
    else
      window.location = process.env.VUE_APP_SITE_URL+'/login'
  },
  methods: {
    ...mapActions(["checkNpsAccess","checkNpsClassAccess","saveNpsFeedbackData"]),
    submitForm() {
      if(this.$v.$invalid) {
        return false;
      }
      this.submitButton = "Submitting";
      const npsPayload = {
        "nps_data" : {
          "delivered_to_promise" : this.form_detail.delivered,
          "recommend_avishkaar_course" : this.form_detail.recommend,
          "course_like_reason" : this.form_detail.likeReason,
          "like_my_teacher" : this.form_detail.likeTeacher,
          "like_about_avishkaar" : this.form_detail.likeMost,
          "reason_of_ration" : this.form_detail.recommendReason,
          "wow" : this.form_detail.wow,
        },
        "courseCode" : this.npsAccess.courseData.product_code,
        "filledFor" : this.form_detail.studentName ? this.form_detail.studentName : "self",
      };
      this.saveNpsFeedbackData(npsPayload).then(() => {
        this.submit = !this.submit;
        this.submitButton = "Submit";
      }).catch(error => {
        console.log(error);
        })
    },
  },
};
</script>

<style scoped>
button {
  outline: none!important;
}
.validate-fail{
  outline: red!important;
  border-color: red!important;
}
label {
  margin: 0;
}

p {
  margin: 0;
}

.required:after {
  content:" *";
  color: red;
}

.banner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1%;
}

.banner {
  width: 70%;
}

.feedback-form {
  background-color: #fff9f6;
  padding: 2%;
  margin: 2% 0 2%;
  border-radius: 10px;
  text-align: left;
  width: 70%;
  font-size: 1.2rem;
}

.feedback {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.heading {
  color: #f36f2e !important;
  margin: 3% 0;
}

.label-head {
  margin: 2rem 0 1rem;
  font-weight: bolder;
}

.fillingForChild {
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  font-weight: bolder;
  margin: 5% 0;
}

.fillingForChild label {
  padding-left: 3%;
}

.name {
  letter-spacing: 0.062rem;
  border: 1px solid rgba(25, 25, 25, 0.32);
  border-radius: 5px;
  opacity: 1;
  background: 0 0;
  background-color: white;
}

.name:focus-visible {
  outline: none;
  border: 1px solid #f36f2e;
}

input[type="radio"] {
  appearance: none;
  border-radius: 50%;
  margin: 10% 0;
  width: 25px;
  height: 25px;
  border: 1px solid rgba(25, 25, 25, 80);
  transition: all 1s;
}

input[type="radio"]:checked {
  border: 12px solid;
  transition: all 0.5s;
}

input[type="radio"]:hover {
  cursor: pointer;
  background-color: rgba(243,111,46, 0.32);
}

.radio-item:nth-of-type(1) input[type="radio"]:checked {
  border-color: #b50e16;
  background-color: #b50e16;
}
.radio-item:nth-of-type(2) input[type="radio"]:checked {
  border-color: #e0101d;
  background-color: #e0101d;
}
.radio-item:nth-of-type(3) input[type="radio"]:checked {
  border-color: #ed2832;
  background-color: #ed2832;
}
.radio-item:nth-of-type(4) input[type="radio"]:checked {
  border-color: #ee474f;
  background-color: #ee474f;
}
.radio-item:nth-of-type(5) input[type="radio"]:checked {
  border-color: #ff6c75;
  background-color: #ff6c75;
}
.radio-item:nth-of-type(6) input[type="radio"]:checked {
  border-color: #95f985;
  background-color: #95f985;
}
.radio-item:nth-of-type(7) input[type="radio"]:checked {
  border-color: #4ded30;
  background-color: #4ded30;
}
.radio-item:nth-of-type(8) input[type="radio"]:checked {
  border-color: #26d701;
  background-color: #26d701;
}
.radio-item:nth-of-type(9) input[type="radio"]:checked {
  border-color: #00c301;
  background-color: #00c301;
}
.radio-item:nth-of-type(10) input[type="radio"]:checked {
  border-color: #00ab08;
  background-color: #00ab08;
}

.only-four.radio-item:nth-of-type(1) input[type="radio"]:checked {
  border-color: #b50e16;
  background-color: #b50e16;
}
.only-four.radio-item:nth-of-type(2) input[type="radio"]:checked {
  border-color: #ee474f;
  background-color: #ee474f;
}
.only-four.radio-item:nth-of-type(3) input[type="radio"]:checked {
  border-color: #4ded30;
  background-color: #4ded30;
}
.only-four.radio-item:nth-of-type(4) input[type="radio"]:checked {
  border-color: #00ab08;
  background-color: #00ab08;
}

.radio {
  display: flex;
  padding: 3%;
  justify-content: space-evenly;
  color: rgba(25, 25, 25, 0.8);
  border: 1px solid rgba(25, 25, 25, 0.32);
  background-color: white;
}

.radio-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.radio-label {
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    color: rgba(34, 10, 10, 0.60);
  }

.check-container {
  border: 1px solid rgba(25, 25, 25, 0.32);
  padding: 3%;
  background-color: white;
}

.check-container label {
  padding-left: 2%;
}

.check-item {
  display: flex;
  align-items: center;
  padding: 1%;
}

.check-item label {
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(34, 10, 10, 0.80);
}

input[type="checkbox"] {
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background-image: url(../assets/images/tick.png);
  background-size: 1%;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid rgba(25, 25, 25, 0.32);
  transition: all 1s;
}

input[type="checkbox"]:hover {
  cursor: pointer;
  background-color: rgba(243,111,46, 0.32);
}

input[type="checkbox"]:checked {
  background-color: #f36f2e;
  background-image: url(../assets/images/tick.png);
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  border: 1px solid #f36f2e;
  transition: all 0.5s;
}

.checkbox:disabled ~ label{
  color: rgb(96, 96, 96, 0.50);
}

.checkbox:disabled:hover{
  background-color: #fff;
}

.details {
    font-size: 1.2rem;
  }

.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 3%;
}

.button-disabled {
  display: flex;
  position: relative;
  font-size: 0.6rem;
  align-items: center;
  justify-content: center;
}

.feedback-success-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedback-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  padding: 2%;
  background-color: #fff9f6;
  margin: 2% 0 2%;
  border-radius: 10px;
}
.in-valid {
  font-size: 0.8rem;
  color: red;
}

@media only screen and (min-width: 600px) and (max-width: 1059px) {
  .feedback-form {
    font-size: 0.8rem;
    width: 85%;
  }
  .feedback-success {
    font-size: 0.8rem;
    width: 85%;
  }
  .banner {
    width: 85%;
  }
  .details {
    font-size: 0.9rem;
  }
  .heading {
    font-size: 1.75rem;
  }
  .radio-label {
    font-size: 0.8rem;
  }
  .check-item label {
    font-size: 0.8rem;
  }
  .fillingForChild label {
    font-size: 0.8rem;
    font-weight: 600;
  }
}
@media only screen and (max-width: 599px) {
  .feedback-form {
    font-size: 0.75rem;
    width: 95%;
  }
  .feedback-success {
    font-size: 0.75rem;
    width: 95%;
  }
  .details {
    font-size: 0.8rem;
  }
  .banner {
    width: 95%;
  }
  .heading {
    font-size: 1.5rem;
  }
  .radio-label {
    font-size: 0.6rem;
  }
  .check-item label {
    font-size: 0.7rem;
  }
  .fillingForChild label {
    font-size: 0.7rem;
  }
}
</style>
